'use client'

import cn from 'clsx'
import type { LenisOptions } from 'lenis'
import type { ComponentProps } from 'react'

import type { Theme } from '~/styles/config'
import { Canvas } from '~/webgl/components/canvas'
import { Banner } from '../banner'
import { Footer } from '../footer'
import { Lenis } from '../lenis'

interface WrapperProps extends ComponentProps<'div'> {
  theme?: Theme
  lenis?: boolean | LenisOptions
  webgl?: boolean | Omit<ComponentProps<typeof Canvas>, 'children'>
}

export function Wrapper({
  children,
  theme,
  className,
  lenis = true,
  webgl,
  ...props
}: WrapperProps) {
  return (
    <>
      {/* avoid flash of unthemed pages */}
      {/* <script>{`document.documentElement.setAttribute('data-theme', '${theme}');`}</script> */}
      {/* avoid flash of unthemed pages */}
      {/* <Background /> */}
      {webgl && (
        <Canvas
          root
          {...(typeof webgl === 'object' && webgl)}
        />
      )}
      {/* <Cursor /> */}
      <main
        className={cn('relative grow px-safe overflow-x-clip z-10', className)}
        {...props}
      >
        <Banner />
        {children}

        <Footer />
      </main>
      {lenis && (
        <Lenis
          root
          options={typeof lenis === 'object' ? lenis : {}}
        />
      )}
    </>
  )
}
